// extracted by mini-css-extract-plugin
export default {"container":"NewCourse_container__ln1hK"};